/* eslint-disable no-restricted-syntax */
// @mui material components
import {
  CircularProgress,
  Backdrop,
  Snackbar,
  Alert,
  Card,
  Icon,
  Button,
  ListItem,
  ListItemText,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios.js";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import MDBox from "theme/components/MDBox";
// import MDInput from "theme/components/MDInput";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";
import MDInput from "components/MDInput";

function LeadBucketPage() {
  const pageTitle = "Lead Bucket";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
    setShowLoading(false);
    setSeverity("error");
  };

  const [pageLoaded, setPageLoaded] = useState(false);

  const [resultData, setResultData] = useState([]);
  const [leads, setLeads] = useState([]);
  const [search, setSearch] = useState("");

  const filteredLeads = leads.filter((lead) => {
    const value = search.toLowerCase();

    return (
      lead.name?.toLowerCase().includes(value) ||
      lead.phone_number?.toLowerCase().includes(value) ||
      lead.email_address?.toLowerCase().includes(value)
    );
  });

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/leads/buckets/${ref}/fetch.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setResultData(result.data.data);
            setLeads(result.data.data.leads);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mb={5}>
        <MDBox display="flex" justifyContent="space-between" mb={2}>
          <MDBox>
            <Button
              color="dark"
              size="small"
              startIcon={<Icon>west</Icon>}
              onClick={() => {
                if (window.history.length > 1) {
                  window.history.back();
                } else {
                  navigate(`/leads/buckets/`);
                }
              }}
            >
              Back
            </Button>
          </MDBox>
        </MDBox>
        {pageLoaded && (
          <MDBox mt={1}>
            <MDBox mb={3}>
              <Card>
                <MDBox p={2} align="center">
                  <MDTypography variant="h6">
                    {resultData.bucket.title}
                  </MDTypography>
                  <MDTypography variant="body2" fontSize={12}>
                    {resultData.bucket.profile}
                  </MDTypography>
                  <MDBox mt={3} align="center">
                    <MDInput
                      fullWidth
                      label="Search leads..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            {leads.length > 0 ? (
              <MDBox>
                {filteredLeads.map((lead) => (
                  <MDBox my={2}>
                    <Card>
                      <MDBox p={2}>
                        <ListItem
                          onClick={() => {
                            navigate(`/leads/${lead.reference}`);
                          }}
                        >
                          <ListItemText
                            primary={
                              <MDTypography variant="h6" fontSize={15}>
                                {lead.name}
                              </MDTypography>
                            }
                            secondary={
                              lead.phone_number
                                ? lead.phone_number
                                : lead.email_address
                            }
                          />
                          <MDBox mb={1}>
                            <MDButton
                              variant="outlined"
                              iconOnly
                              size="small"
                              color="primary"
                            >
                              <Icon>east</Icon>
                            </MDButton>
                          </MDBox>
                        </ListItem>
                      </MDBox>
                    </Card>
                  </MDBox>
                ))}
              </MDBox>
            ) : (
              <Card>
                <MDBox align="center" p={2}>
                  <MDTypography fontSize={48}>
                    <Icon>warning</Icon>
                  </MDTypography>
                  <MDTypography variant="body2">
                    You have not been assigned any leads yet.
                  </MDTypography>
                </MDBox>
              </Card>
            )}
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default LeadBucketPage;
